<template>
  <section :class="['sample-form', `sample-form--${pageMode}`, `sample-form--${showForm}`]" :style="backgroundSettings" id="main-form-container">
    <div class="sample-form__container" >
      <div class="sample-form__aside" v-if="pageMode === 'suppliers'">
        <!-- <img :src="assetPath + 'materials/roast-sample-kit.png'" alt="" width="100" height="100"> -->
        <h2>Exclusive Offers for Your Customers</h2>
        <img class="sample-form__image--mobile" :src="`${assetPath}materials/offers-final.png`" alt="" width="469" height="280">
        <!-- <p>Get samples of premium roasts from Caf&eacute; Bustlo<sup>&reg;</sup> and 1850<sup>&reg;</sup> along with a tasting guide to seal the sale.</p> -->
        <OptionExplanation page-mode="suppliers" v-if="this.$store.state.sampleForm" />
        <img class="sample-form__image--desktop" :src="`${assetPath}materials/offers-final.png`" alt="" width="469" height="280">
      </div>
      <div id="form-header" v-if="pageMode === 'managers'">
        <h2>Exclusive Offers Just for You</h2>
        <!-- <p>Whether you’re already back in the office or gearing up for a return we have the kit you need build comradery over coffee. Your kit includes fun office ice breakers, helpful signage and the employee Breakroom Faves Survey.</p> -->
        <OptionExplanation page-mode="managers" v-if="this.$store.state.sampleForm" />
      </div>
      <!-- <WelcomeKit  @rcfail="resetRC" @executeRC="executeRC" /> -->
      <!-- <RoastKit v-if="pageMode === 'suppliers'" @rcfail="resetRC" @executeRC="executeRC" /> -->
      <OptionsForm @rcfail="resetRC" @executeRC="executeRC" />
    </div>
  </section>
</template>

<script>
import { pageMode } from '../../mixins/pageMode.js'
import { assetPath } from '../../mixins/assetPath.js'

// import WelcomeKit from './WelcomeKit.vue'
// import RoastKit from './RoastKit.vue'
import OptionsForm from './OptionsForm.vue'
import OptionExplanation from './OptionsExplanation.vue'
// import FolgersLogo from '@/assets/brands/Folgers_Logo-HEADER.svg'

export default {
  name: 'MainFormContainer',
  components: {
    // WelcomeKit,
    // RoastKit,
    // FolgersLogo,
    OptionsForm,
    OptionExplanation
  },
  computed: {
    backgroundSettings() {
      return (this.pageMode === 'managers') ? `background-image: url(${this.assetPath}form-backgrounds/MainFormBGLeft.png), url(${this.assetPath}form-backgrounds/MainFormBGRight.png), url(${this.assetPath}form-backgrounds/MainFormBGMan.jpg);` : `background-image: url(${this.assetPath}form-backgrounds/MainFormBGSupp.jpg)`
    },
    showForm () {
      return this.$store.state.sampleForm ? 'form' : 'thanks'
    }
  },
  methods: {
    resetRC() {
      this.$emit('resetRC')
    },
    executeRC() {
      this.$emit('executeRC')
    }
  },
  mixins: [pageMode, assetPath]
}
</script>
<style lang="scss">

.sample-form {
  padding: 40px 0;
  background-color: #fff;
  position: relative;
}

.sample-form--managers {
  background-repeat: no-repeat;
  background-position: -9000px -9000px, -9000px -9000px, center center;
  background-size: contain, contain, cover;
  @include breakpoint(xlarge) {
    background-position: left bottom, right bottom, center center;
  }
}

.sample-form--suppliers {
  background-repeat: no-repeat;
  background-size: cover;
}

.sample-form--managers.sample-form--thanks {
  background-size: 20%, 20%, cover;
}

.sample-form__container {
  max-width: 572px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 30px;
  padding-right: 30px;
  text-align: center;
  p {
    margin-top: 0px;
    color: #8A8C8E;
    font-size: 14px;
    line-height: 20px;
    padding: 0px 15px;
    margin-bottom: 20px;
  }
  h2 {
    color: $blue;
  }
  /* img {
    max-width: 100px;
    margin: 0 auto;
  } */
}

.sample-form--suppliers {
  .sample-form__container {
    display: flex;
    flex-direction: column;
    max-width: 920px;
    gap: 2em;
  }
  @include breakpoint(xlarge) {
    .sample-form__container {
      flex-direction: row;
      & > div {
        flex: 0 0 calc(50% - 1em);
      }
    }
  }
}

.sample-form__image--mobile {
  display: block;
  margin: 0 auto;
  @include breakpoint(xlarge) {
    display: none;
  }
}

.sample-form__image--desktop {
  display: none;
  @include breakpoint(xlarge) {
    display: block;
    margin: 0 auto;
  }
}

.sample-form__logo {
  position: relative;
  width: 180px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 25px;
  padding-left: 30px;
  padding-right: 30px;
  p {
    position: absolute;
    right: 10px;
    top: 38px;
    font-size: 12px;
    line-height: 15px;
    color: #8A8C8E;
    padding: 0px;
  }
}

.sample-form__video {
  margin-bottom: 33px;
  position: relative;
  overflow: hidden;
  padding-bottom: 56.25%;
  iframe {
    border: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
}

</style>